import Module from '../../utils/modules/Module';
import EventsManager from '../../utils/events/EventsManager';
import CustomEvents from '../../utils/events/CustomEvents';
import gsap from 'gsap';
import CustomEase from '../../utils/transitions/CustomEase.min';

export default class HeaderModule extends Module {
  constructor(options) {
    super(options)

    //BINDING
    this.onOpenDropDown = this.onOpenDropDown.bind(this);
    this.toggleMenuBurger = this.toggleMenuBurger.bind(this);
    this.toggleNavSearch = this.toggleNavSearch.bind(this);
    this.onCloseDropdown = this.onCloseDropdown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.toggleMenuBurger = this.toggleMenuBurger.bind(this);

    //DOM ELEMENTS
    this.DOMEl = this.options.element;
    this.header = this.DOMEl.querySelector(".header__nav");
    this.dropdownButtons = this.DOMEl.querySelectorAll("button.menu-main-link");
    this.menuPanelsWrapper = this.DOMEl.querySelector(".menu-pannels-wrapper");
    this.menuMainPanel = this.DOMEl.querySelector(".menu-panel--main");
    this.menuSecondairyPanel = this.DOMEl.querySelector(".menu-panel--secondairy");
    this.navLinksMain = this.DOMEl.querySelectorAll(".menu-panel--main .menu-main-link");
    this.submenus = this.menuSecondairyPanel.querySelectorAll(".submenu");
    this.burgerBtn = this.DOMEl.querySelector(".burger-menu-btn");
    this.searchBtn = this.DOMEl.querySelector(".navsearch-open");
    this.searchContainer = this.DOMEl.querySelector('.navsearch-container');
    this.backgroundMenu = this.DOMEl.querySelector(".main-popup__close-background");
    this.mobilePopupMenu = this.DOMEl.querySelector(".nav__main-popup");
    this.backButton = this.DOMEl.querySelector('.mobile-back-btn');
    this.dismisser = document.querySelectorAll('[data-dismiss]');

    //VARIABLES
    this.savedScrolledPos = 0;
    gsap.registerPlugin(CustomEase);
    CustomEase.create("easeOutExpo", "0.16, 1, 0.3, 1");

    //TIMELINE ANIMATIONS
    this.timelineclose = gsap.timeline({
      onComplete: () => {
        //RESET ON COMPLETE
        this.burgerBtn.classList.remove("active")
        this.mobilePopupMenu.style.display = "none";

        gsap.set(this.mobilePopupMenu, {clearProps: 'opacity'});
        //gsap.set(this.menuMainPanel, {clearProps: 'transform'});
        gsap.set(this.backgroundMenu, {clearProps: 'opacity'});

        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scroll({
          top: parseInt(scrollY || '0') * -1,
          behaviour: 'auto'
        });

        document.getElementsByTagName("html")[0].classList.remove('set-scroll-behaviour-auto');

        this.resetDropDowns();
      }
    }).pause();

    this.timelineclose.to(this.menuSecondairyPanel,{css: {'transform': 'scaleX(0)'}, duration: 0.6,ease:'easeOutExpo'},'-=0.2');
    this.timelineclose.fromTo(this.menuMainPanel, {css: {'transform': 'translate3d(0, 0 ,0)'}}, {css: {'transform': 'translate3d(-100%, 0 ,0)'}, duration: 0.6,ease:'easeOutExpo'}, '-=0.2');
    this.timelineclose.fromTo(this.backgroundMenu, {opacity: 0.4}, {opacity: 0, duration: 0.3});


    this.timelineOpen = gsap.timeline().pause();
    this.timelineOpen.to(this.backgroundMenu, {opacity: 0.4, duration: 0.3});
    this.timelineOpen.fromTo(this.menuMainPanel, {css: {'transform': 'translate3d(-100%, 0 ,0)'}}, {css: {'transform': 'translate3d(0, 0 ,0)'}, duration: 0.6,ease:'easeOutExpo'}, '-=0.2');

    this.init();
  }

  init() {
    let self = this;
    this.backgroundMenu.addEventListener('click', this.toggleMenuBurger);
    this.burgerBtn.addEventListener("click", this.toggleMenuBurger);
    this.searchBtn.addEventListener("click", this.toggleNavSearch);

    // handle clickout -> close search
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.navsearch-wrapper') || event.target.classList.contains('navsearch-close')) {
        if (self.searchContainer.classList.contains('open')) {
          self.toggleNavSearch(event);
        }
      }
    });

    // close everything on escape key
    document.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        self.toggleNavSearch(event);

        if (self.burgerBtn.classList.contains("active")) {
          self.toggleMenuBurger(event);
        }
      }
    });

    this.dropdownButtons.forEach(button => {
      button.addEventListener('click', this.onOpenDropDown);
    });

    this.menuMainPanel.addEventListener('click', this.onCloseDropdown)
    this.backButton.addEventListener('click', this.onCloseDropdown)

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
    this.onLoad();
    this.onScroll();
    this.onResize();

    //accessibility
    this.burgerBtn.addEventListener("focusout", function () {
      if (self.burgerBtn.classList.contains('active')) {
        self.navLinksMain[0].focus();
      }
    });

    this.dismisser.forEach((el) => {
      el.addEventListener('click', this.onDismissClick);
    });
  }

  onLoad() {
    EventsManager.broadcast(CustomEvents.commons.moduleLoaded, 'HeaderMenuDesktopModule');

    if (window.location.href.match('item-id')) {
      this.openListItem(new URL(window.location.href).searchParams.get("item-id"));
    }
  }


  // Shorten breadcrumb for mobile
  onResize() {
    if (document.querySelectorAll('.breadcrumb-item').length > 1) {
      let breadcrumbItems = document.querySelectorAll('.breadcrumb-item');
      let breadcrumbParentItem = document.querySelector('.breadcrumb-item:last-of-type').previousElementSibling;

      if (window.innerWidth < 600) {
        breadcrumbItems.forEach(el => el.style.display = 'none');
        breadcrumbParentItem.style.display = 'initial';
        breadcrumbParentItem.classList.add('breadcrumb-item-mobile');
      } else {
        breadcrumbItems.forEach(el => el.style.display = 'initial');
        breadcrumbParentItem.classList.remove('breadcrumb-item-mobile');
      }
    }

    if (this.searchContainer.classList.contains('open')) {
      this.searchContainer.style.height = document.querySelector('.navsearch-container-inner').clientHeight + 'px';
    }
  }


  // hide or display menu on scroll
  onScroll(e) {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);

    let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    let scrollDirection = '';

    if (currentScroll > 0 && this.savedScrolledPos <= currentScroll) {
      this.savedScrolledPos = currentScroll;
      scrollDirection = 'down';
    } else {
      this.savedScrolledPos = currentScroll;
      scrollDirection = 'up';
    }

    if (window.innerWidth > 767) {
      if (window.pageYOffset < 20) {
        this.DOMEl.classList.remove("header-container--hide")
      } else {
        if (window.pageYOffset > 20 && scrollDirection === "down") {
          this.DOMEl.classList.add("header-container--hide")
        } else if (window.pageYOffset > 20 && scrollDirection === "up") {
          this.DOMEl.classList.remove("header-container--hide")
        }
      }
    }
    this.savedScrolledPos = document.documentElement.scrollTop;
  }


  // TOGGLE OPENING AND CLOSE SEARCH SECTION
  toggleNavSearch(e) {
    let self = this;
    const html = document.querySelector('html');

    // go to open state
    if (!this.searchContainer.classList.contains('open') && e.target.classList.contains('navsearch-btn')) {
      this.searchContainer.removeAttribute('hidden');
      html.classList.add('no-scroll', 'shadow', 'shadow-nav', 'fadeIN');

      setTimeout(function () {
        self.searchContainer.classList.add('open');

        // handle search focusout -> no tab trap
        self.searchContainer.querySelector('.navsearch-submit').addEventListener('focusout', function () {
          self.searchContainer.querySelector('.navsearch-input').focus();
        });
        self.searchContainer.firstElementChild.addEventListener('focus', function () {
          self.searchContainer.querySelector('.navsearch-input').focus();
        });
      }, 5);

      setTimeout(function () {
        html.classList.remove('fadeIN');
        self.searchContainer.style.height = document.querySelector('.navsearch-container-inner').clientHeight + 'px';
      }, 500);

      setTimeout(function () {
        self.searchContainer.querySelector('.navsearch-input').focus();
      }, 1000);
    }
    // go to close state
    else {
      html.classList.add('fadeOUT');
      self.searchContainer.style.height = document.querySelector('.navsearch-input').clientHeight + 'px';

      setTimeout(function () {
        self.searchContainer.classList.remove('open');
      }, 400);

      setTimeout(function () {
        self.searchContainer.setAttribute('hidden', "true");
        html.classList.remove('no-scroll', 'shadow', 'shadow-nav', 'fadeOUT');
      }, 1000);
    }

  }

  // TOGGLE OPENING AND CLOSE MENU
  toggleMenuBurger() {
    let self = this;

    if (!this.burgerBtn.classList.contains("active")) {
      this.burgerBtn.classList.add("active");
      this.mobilePopupMenu.style.display = "block";

      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;

      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
      document.getElementsByTagName("html")[0].classList.add('set-scroll-behaviour-auto');

      gsap.delayedCall(0.1, () => {
        this.timelineOpen.restart();
      })

    } else {
      this.timelineclose.restart();
    }

    // cookie
    document.querySelector('.ot-floating-button').classList.toggle('hide');

    // accessibility
    let goCloseTrigger = document.querySelectorAll('.go-to-close');
    // -> on open first panel
    this.navLinksMain[0].focus();
    // -> before first item & after last item
    goCloseTrigger.forEach(function (el) {
      el.addEventListener("focus", function () {
        self.burgerBtn.focus();
      });
    });
  }


  onOpenDropDown(e) {
    let self = this;
    if (e.target.tagName === 'BUTTON' && e.target.classList.contains('active-submenu-btn')) return;

    this.resetDropDowns();

    e.target.classList.add('active-submenu-btn');

    const submenuId = e.target.getAttribute('data-menu-button');
    const submenuToOpen = [...this.submenus].filter(menu => menu.getAttribute('data-menu-index') === submenuId)[0];

    gsap.set(submenuToOpen, {clearProps: 'opacity'});

    this.menuSecondairyPanel.style.display = 'block';
    submenuToOpen.style.display = 'block';

    if (window.innerWidth > 769) {
      submenuToOpen.classList.add('active-submenu')
      gsap.to(this.menuSecondairyPanel, {css: {'transform': 'scaleX(1)'}, duration: 0.6,ease:'easeOutExpo'})
      gsap.to(submenuToOpen, {opacity: 1, duration: 0.3, delay: 0.3})
    } else {
      this.backButton.style.display = 'block';
      this.burgerBtn.style.display = 'none';
      gsap.to(this.menuPanelsWrapper, {css: {'transform': 'translateX(-50%)'}, duration: 0.3})
    }

    // Accessibility
    let navLinksSecondary = document.querySelectorAll('.active-submenu a');
    let intParentLink = document.querySelector('.active-submenu').getAttribute('data-menu-index');
    let goBackTrigger = document.querySelectorAll('.go-to-prev');

    // -> on open second panel
    setTimeout(function () {
      navLinksSecondary[0].focus();
    }, 310);
    // -> before first item & after last item
    goBackTrigger.forEach(function (el) {
      el.addEventListener("focus", function () {
        self.navLinksMain[intParentLink - 1].focus();
        self.onCloseDropdown(navLinksSecondary[0]);
      });
    });
  }


  onCloseDropdown(e) {
    if (e.target.tagName === 'BUTTON' && e.target.classList.contains('active-submenu-btn')) return;

    this.DOMEl.querySelectorAll('button.active-submenu-btn').forEach(button => button.classList.remove('active-submenu-btn'));
    const activeMenu = this.DOMEl.querySelectorAll(".active-submenu")

    if (window.innerWidth > 769) {
      gsap.to(activeMenu, {opacity: 0, duration: 0.2, stagger: 0})
      gsap.to(this.menuSecondairyPanel, {
        css: {'transform': 'scaleX(0)'}, duration: 0.6, delay: 0.2,ease:'easeOutExpo', onComplete: () => {
          this.resetDropDowns();
        }
      });
    } else {
      this.backButton.style.display = 'none';
      this.burgerBtn.style.display = 'flex';
      gsap.to(this.menuPanelsWrapper, {
        css: {'transform': 'translateX(0%)'}, duration: 0.3, onComplete: () => {
          this.resetDropDowns();
        }
      });
    }
  }


  resetDropDowns() {
    this.menuSecondairyPanel.style.display = 'none';
    this.DOMEl.querySelectorAll('button.active-submenu-btn').forEach(button => button.classList.remove('active-submenu-btn'));
    this.DOMEl.querySelectorAll(".active-submenu").forEach(menu => {
      menu.style.display = 'none';
      menu.classList.remove('active-submenu')
    });
  }

  openListItem(id) {
    let item = document.querySelector('.list-item[data-id="' + id + '"]');

    item.closest('.list-wrapper').scrollIntoView({
      behavior: 'smooth'
    });

    setTimeout(function () {
      item.click();
    }, 800);
  }

  onDismissClick(ev) {
    let dismissableElement = ev.target.dataset.dismiss;
    let $dismissableTarget = ev.target.closest(`.${dismissableElement}`);

    $dismissableTarget.classList.remove('is-active');
  }
}
